import { useNavigate } from 'react-router';
import { Button } from '~/components/granular/button';
import { FormattedMessage } from '~/intl';
import { FormFooter } from './FormFooter';
import type { FormSubmitFooterProps } from './FormFooter.types';

export function FormSubmitFooter({ submitLabel, isPending, submitDisabled, cancelTo }: FormSubmitFooterProps) {
  const navigate = useNavigate();

  const handleCancel = () => {
    if (cancelTo) {
      navigate(cancelTo);
      return;
    }
    navigate(-1);
  };

  return (
    <FormFooter>
      <Button appearance="secondary" onClick={handleCancel} size="medium" type="button">
        <FormattedMessage id="common.cancel" />
      </Button>
      <Button disabled={submitDisabled} loading={isPending} size="medium" type="submit">
        {submitLabel}
      </Button>
    </FormFooter>
  );
}
